module.exports = __webpack_public_path__ + "img/add_user.16088038.svg";